module.exports = __webpack_public_path__ + "static/media/gameplay_bg_ancient.0d6e5c1a.jpg";